import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  UserRole_Admin_getInstance3u101dj1ubbhu as UserRole_Admin_getInstance,
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor,
  get_contractorStatus37lp78am5imju as get_contractorStatus,
} from '../../../selectedContractor.mjs';
import {
  get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator,
  get_pageNavigator1inl9j7ja0vlf as get_pageNavigator,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LandingScreennv9edtrim3be as LandingScreen } from '../common/LandingScreen.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ContractorNewRegistration1u860bdbb1seh as ContractorNewRegistration } from '../auth/NewContractorRegistration.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../theming/banners.mjs';
import {
  get_atEnd1cw5d2zgug26 as get_atEnd,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Action1a4ymn5nx79hk as Action } from '../../../utils/utils.mjs';
import { body3i5t0n7zprpqb as body } from '../../theming/Titles.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_verifyContractor__9zqgai(_this__u8e3s4, roleRequirement, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp.pfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var self_0 = tmp_0;
  if (self_0.o88_1.d4(UserRole_Admin_getInstance()) >= 0)
    return Unit_instance;
  var membership = self_0.m88_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_selectedContractor();
  var tmp_1 = await_1(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var selected = tmp_1;
  if (membership == null || membership.j8c_1.d4(roleRequirement) < 0) {
    get_mainPageNavigator(_this__u8e3s4).ebw(new (LandingScreen())());
  } else if (!membership.i8c_1.equals(selected)) {
    get_selectedContractor().mam(membership.i8c_1);
  }
  return Unit_instance;
}
function verifyContractor(_this__u8e3s4, roleRequirement, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_verifyContractor__9zqgai.bind(VOID, _this__u8e3s4, roleRequirement), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = verifyContractor($this.xjm_1, $this.yjm_1.bhg(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ContractorPage$renderFinishRegistration$slambdaClass;
function ContractorPage$renderFinishRegistration$slambda() {
  if (ContractorPage$renderFinishRegistration$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.zjm_1 = $$this$button;
      }
      wah($this$Action, $completion) {
        get_pageNavigator(this.zjm_1).ebw(new (ContractorNewRegistration())());
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorPage$renderFinishRegistration$slambdaClass = $;
  }
  return ContractorPage$renderFinishRegistration$slambdaClass;
}
function ContractorPage$renderFinishRegistration$slambda_0($$this$button) {
  var i = new (ContractorPage$renderFinishRegistration$slambda())($$this$button);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var ContractorPage$render$slambdaClass;
function ContractorPage$render$slambda() {
  if (ContractorPage$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$frame, this$0) {
        this.xjm_1 = $$this$frame;
        this.yjm_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorPage$render$slambdaClass = $;
  }
  return ContractorPage$render$slambdaClass;
}
function ContractorPage$render$slambda_0($$this$frame, this$0) {
  var i = new (ContractorPage$render$slambda())($$this$frame, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function get_requiredMembershipRole() {
  return MemberRole_Employee_getInstance();
}
function get_awaitingApprovalMessage() {
  return "Your account is currently awaiting approval. You will have limited access until approved. Once reviewed, you'll receive a notification confirming your account status.";
}
function renderFinishRegistration(_this__u8e3s4) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp_0 = notificationBar(view, AppColors_getInstance().ifz_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp_1 = view_0.ibb(get_atEnd(view_0), get_tertiaryButton(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  specCenteredText(view_1, 'Finish Registration');
  view_1.mbg(Action('Go To Registration', VOID, ContractorPage$renderFinishRegistration$slambda_0(view_1)));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_1, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function renderAwaitingApproval(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().zg1_1);
  var tmp = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), notificationBar(view, AppColors_getInstance().jfz_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  body(view_0, this.dhg());
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  get_expanding(view);
  this.rhi(view);
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance();
  _this__u8e3s4.fbb(p, view);
}
function render(_this__u8e3s4) {
  var tmp = get_expanding(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var $this$frame = view;
  $this$frame.eba(get_px(0));
  $this$frame.zb8(get_px(0));
  launch($this$frame, VOID, VOID, ContractorPage$render$slambda_0($this$frame, this));
  reactive($this$frame, ($this$reactive) => {
    $this$frame.zb9();
    var tmp0_elvis_lhs = $this$reactive.baj(get_contractorStatus());
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      get_pageNavigator($this$frame).ebw(new (LandingScreen())());
      throw CancellationException().ld('No Contractor');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var active = tmp;
    var tmp_0;
    switch (active.b4_1) {
      case 0:
        this.ehg($this$frame);
        tmp_0 = Unit_instance;
        break;
      case 1:
        this.fhg($this$frame);
        tmp_0 = Unit_instance;
        break;
      case 2:
        this.rhi($this$frame);
        tmp_0 = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  });
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
var ContractorPageClass;
function ContractorPage() {
  if (ContractorPageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ContractorPage', VOID, VOID, [Page()]);
    ContractorPageClass = $;
  }
  return ContractorPageClass;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = verifyContractor($this.ajn_1, $this.bjn_1.bhg(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var MightBeContractorPage$renderFinishRegistration$slambdaClass;
function MightBeContractorPage$renderFinishRegistration$slambda() {
  if (MightBeContractorPage$renderFinishRegistration$slambdaClass === VOID) {
    class $ {
      constructor($$this$button) {
        this.cjn_1 = $$this$button;
      }
      wah($this$Action, $completion) {
        get_pageNavigator(this.cjn_1).ebw(new (ContractorNewRegistration())());
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    MightBeContractorPage$renderFinishRegistration$slambdaClass = $;
  }
  return MightBeContractorPage$renderFinishRegistration$slambdaClass;
}
function MightBeContractorPage$renderFinishRegistration$slambda_0($$this$button) {
  var i = new (MightBeContractorPage$renderFinishRegistration$slambda())($$this$button);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var MightBeContractorPage$render$slambdaClass;
function MightBeContractorPage$render$slambda() {
  if (MightBeContractorPage$render$slambdaClass === VOID) {
    class $ {
      constructor($$this$frame, this$0) {
        this.ajn_1 = $$this$frame;
        this.bjn_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    MightBeContractorPage$render$slambdaClass = $;
  }
  return MightBeContractorPage$render$slambdaClass;
}
function MightBeContractorPage$render$slambda_0($$this$frame, this$0) {
  var i = new (MightBeContractorPage$render$slambda())($$this$frame, this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function get_requiredMembershipRole_0() {
  return MemberRole_Employee_getInstance();
}
function get_finishRegistrationMessage() {
  return 'You need to finish registering before you can see this';
}
function get_awaitingApprovalMessage_0() {
  return 'Your account is currently awaiting approval. You will have limited access until approved.';
}
function renderFinishRegistration_0(_this__u8e3s4) {
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var tmp_0 = notificationBar(view, AppColors_getInstance().ifz_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp0_safe_receiver = this.chg();
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = body(view_0, tmp0_safe_receiver);
  }
  if (tmp_1 == null) {
    get_pageNavigator(view_0).ebw(new (ContractorNewRegistration())());
  }
  var tmp_2 = view_0.ibb(get_atEnd(view_0), get_tertiaryButton(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  specCenteredText(view_1, 'Finish Registration');
  view_1.mbg(Action('Go To Registration', VOID, MightBeContractorPage$renderFinishRegistration$slambda_0(view_1)));
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_2, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function renderAwaitingApproval_0(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().zg1_1);
  var tmp = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1), notificationBar(view, AppColors_getInstance().jfz_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  body(view_0, this.dhg());
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  this.shf(view);
  _this__u8e3s4.fbb(p, view);
}
function render_0(_this__u8e3s4) {
  println('Rendering MightBeContractorPage');
  var tmp;
  switch (this.rgj().b4_1) {
    case 0:
      var tmp_0 = get_expanding(_this__u8e3s4);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call

      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call

      var view = new (Frame())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      var $this$frame = view;
      $this$frame.eba(get_px(0));
      $this$frame.zb8(get_px(0));
      launch($this$frame, VOID, VOID, MightBeContractorPage$render$slambda_0($this$frame, this));
      reactive($this$frame, ($this$reactive) => {
        $this$frame.zb9();
        var tmp0_elvis_lhs = $this$reactive.baj(get_contractorStatus());
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.run' call
          get_pageNavigator($this$frame).ebw(new (LandingScreen())());
          throw CancellationException().ld('No Contractor');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var active = tmp;
        var tmp_0;
        switch (active.b4_1) {
          case 0:
            this.ehg($this$frame);
            tmp_0 = Unit_instance;
            break;
          case 1:
            this.fhg($this$frame);
            tmp_0 = Unit_instance;
            break;
          case 2:
            tmp_0 = this.shf($this$frame);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp_0;
      });
      _this__u8e3s4.fbb(p, view);
      tmp = _this__u8e3s4.jbb(tmp_0, view);
      break;
    case 1:
    case 2:
      tmp = this.shf(_this__u8e3s4);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var MightBeContractorPageClass;
function MightBeContractorPage() {
  if (MightBeContractorPageClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MightBeContractorPage', VOID, VOID, [Page()]);
    MightBeContractorPageClass = $;
  }
  return MightBeContractorPageClass;
}
//region block: exports
export {
  get_awaitingApprovalMessage as get_awaitingApprovalMessagemcfmnhjri98l,
  renderAwaitingApproval as renderAwaitingApprovalsh6ugtdyt2je,
  renderFinishRegistration as renderFinishRegistrationbdw1wx3e9bul,
  render as render2bonfr4ls49sc,
  get_requiredMembershipRole as get_requiredMembershipRole2ywu1e77bwer8,
  ContractorPage as ContractorPage2yk275fy06uv3,
  get_awaitingApprovalMessage_0 as get_awaitingApprovalMessage2f85iqlczrbum,
  get_finishRegistrationMessage as get_finishRegistrationMessage1yrf9ce4f09f0,
  renderAwaitingApproval_0 as renderAwaitingApproval2nft16oqsuwts,
  renderFinishRegistration_0 as renderFinishRegistrationc1cqjl7so0e8,
  render_0 as render2ibcvtmr1nr93,
  get_requiredMembershipRole_0 as get_requiredMembershipRole1cjo4vwylx1kv,
  MightBeContractorPage as MightBeContractorPage1c5hm6d3mwsqz,
  verifyContractor as verifyContractor3ixd4tkg6xaiu,
};
//endregion

//# sourceMappingURL=IsContractorScreen.mjs.map
